import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import { set } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";

const AwardPropertyPopup = ({
  awardPopupModal,
  setAwardPopupModal,
  selectedTenants,
  property,
}) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const [rent, setRent] = useState(property?.report_rent ?? null);
  const [deposit, setDeposit] = useState(property?.report_deposit ?? null);

  const { updateRentDepositReport } = useContext(LandLordContext);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    setRent(property?.report_rent);
    setDeposit(property?.report_deposit);
  }, [property]);

  const handleChangeRent = (e) => {
    setRent(e.target.value);
  };

  const handleDepositChange = (e) => {
    setDeposit(e.target.value);
  };

  const handleGenerateReport = () => {
    let queryParams = "";

    const data_temp = {
      report_rent: rent,
      report_deposit: deposit,
    };
    updateRentDepositReport(property?._id, data_temp);

    selectedTenants.map((tenantProfile) => {
      if (user?.isParentLL) {
        queryParams += `agencylink=${tenantProfile?.agency_tenant_link_id}&`;
      } else {
        queryParams += `sharedprofileid=${tenantProfile?._id}&`;
      }
    });
    queryParams += `rent=${rent}`;
    if (haveValue(property?._id)) {
      queryParams += `&property=${property?._id}`;
    }

    navigate(`/generatedReport/combinedReport?${queryParams}`);
    // `/generatedReport/${sharedProfileId}?sharedprofileid=${sharedProfileId}&rent=${rent}`
  };

  return (
    <Modal
      show={awardPopupModal}
      className="metermodal modal-xl custom-modal-popup"
      centered
      onHide={() => setAwardPopupModal(false)}
    >
      <Modal.Header closeButton>
        <h2>
          {_t(
            "generateReportAndAwardPropertyHeading",
            "Award property/Generate report popup heading when LL selects tenants from property list.."
          )}
        </h2>
      </Modal.Header>
      <Modal.Body>
        <div className="bodyContentset">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="forminput row100 bodyContentset">
              <label className="forminput forminput2">
                {_t("Rent Price", "Award property popup form label")}
              </label>
              <input
                type="number"
                name="Rent Price"
                placeholder={_t(
                  "Enter Rent Price",
                  "Award property popup form placeholder"
                )}
                value={rent}
                onChange={handleChangeRent}
              />
            </div>
            <div className="forminput row100 bodyContentset">
              <label className="forminput forminput2">
                {_t(
                  "Number Of Deposit Month",
                  "Award property popup form label"
                )}
              </label>
              <input
                type="number"
                name="Enter months"
                onChange={handleDepositChange}
                placeholder={_t(
                  "Enter months",
                  "Award property popup form placeholder"
                )}
                value={deposit}
              />
            </div>
            <div className=" row100 gridbar popup_btn2">
              <button
                className="btn btngreen display-block w-100"
                type="submit"
                onClick={handleGenerateReport}
                disabled={!haveValue(rent) || !haveValue(deposit)}
              >
                {_t("submit")}
              </button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AwardPropertyPopup;
